import React from 'react'
import { object, func, string } from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'

class Captcha extends React.Component {
  componentDidUpdate = () => {
    const { instance } = this.props
    if (instance.getValue()) {
      instance.reset()
    }
  }

  render() {
    const { siteKey, onRecaptchaRendered, onSubmit } = this.props
    return (
      <ReCAPTCHA
        className="captcha-field"
        sitekey={siteKey}
        size="invisible"
        onChange={onSubmit}
        ref={onRecaptchaRendered}
      />
    )
  }
}

Captcha.propTypes = {
  siteKey: string.isRequired,
  instance: object,
  onRecaptchaRendered: func.isRequired,
  onSubmit: func.isRequired
}

export default Captcha
